<section *ngIf="userInfo" class="vh-100 d-flex flex-column overflow-auto">
  <nav class="header flex-grow-0">
    <div class="bg-primary bottom-border py-1">
      <div class="container">
        <div
          class="d-flex align-items-center top-nav justify-content-between text-white">
          <div class="flex-grow-0 nav-block end-border">
            <div>
              <a>
                <img
                  src="assets/images/logo.png"
                  height="45"
                  alt="logo"
                  title="takid" loading="lazy" />
              </a>
            </div>
          </div>
          <div
            class="nav-block flex-fill d-flex justify-content-end justify-content-md-between align-items-center end-border dina">
            <div class="d-none d-md-block">
              <p class="text-info mb-1" translate="welcome_to_your_dashboard"></p>
              <h5 class="m-0">
                {{ userInfo.firstName }} {{ userInfo.middleName }} {{
                userInfo.lastName }}
              </h5>
            </div>

            <div class="d-flex justify-content-center gap-2 Qr">

              <!-- <video class="video" autoplay="autoplay" loop="loop" width="100px"
                height="60px">
                <source src="assets/images/Uhy5.gif.mp4" type="video/mp4" />
              </video> -->

              <div>
                <!-- <h6 class="text">Digital Chip</h6><img
                  src="assets/images/barcode.svg" class="img-fluid image"> -->
              </div>

            </div>

            <div class="d-flex gap-2 langNoti">
              <div class="alert-icon" (click)="onLanguageChange()">
                <ion-icon name="language" class="fs-5"></ion-icon>
              </div>
              <div class="dropdown" (click)="displayNotify()">
                <div class="alert-icon notifications" id="dropdownMenuButton"
                  data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fa-solid fa-bell active"></i>
                  <span class="badge" *ngIf="totalCount > 0">{{ totalUnreadNotifications }}</span>
                </div>

                <ul
                  class="dropdown-menu notification text-capitalize p-0 w-fit rounded-12"
                  aria-labelledby="dropdownMenuButton">
                  <li>
                    <div>
                      <div class="main">
                        <div class="d-flex justify-content-between">
                          <a class="m-3 cursor-pointer"style="
                          font-size: 16px;
                          color: #12123c;
                          font-weight: bold;
                          background-color: #f7f7fa;" (click)="redirect()">{{"notifications.showAll" | translate}}</a>
                        <h3 class="m-3" style="
                          font-size: 20px;
                          color: #12123c;
                          font-weight: bold;
                          background-color: #f7f7fa;
                        " translate="lastActivity"></h3>
                      
                      </div>
                        <hr />
                        <div class="search-results-container"
                          [scrollWindow]="false" infiniteScroll
                          [infiniteScrollDistance]="scrollDistance"
                          [infiniteScrollUpDistance]="scrollUpDistance"
                          [infiniteScrollThrottle]="throttle"
                          (scrolled)="onScrollDown()">
                          <div class="container">
                            <div class="row">
                              <div
                                *ngFor="let notify of AllNotify; let i = index">
                                <div class="cardd mt-1">
                                  <div class="row">
                                    <div class="col-3">
                                      <img class=""
                                      style="width:65px;"
                                        src="assets/images/icons/notificationsIcons/{{
                                        notify.notificationType
                                      }}.svg" alt="notification" loading="lazy" alt="assets/images/icons/notificationsIcons/1.svg"  onerror="this.src='assets/images/icons/notificationsIcons/1.svg'" />
                                    </div>
                                    <div class="col-9">
                                      <h5 class="title text-muted"
                                        style="font-size: 12px; margin: auto">
                                        {{ notify.created.slice(11, 16) }}
                                      </h5>
                                      <p>
                                        {{
                                        (lang.isAr | async)
                                        ? modified(notify.description)
                                        : modified(notify.descriptionEn) }}
                                      </p>
                                      <h5 class="title text-muted"
                                        style="font-size: 12px">
                                        {{
                                        notify.created.split(
                                        "
                                        "
                                        )[0]
                                        }}
                                      </h5>
                                    </div>
                                  </div>
                                  <div class="body">
                                    <hr />
                                  </div>
                                </div>
                              </div>
                              <div id="loading" class="lds-ellipsis">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="nav-block flex-grow-0 p-0 px-md-2" *ngIf="step == 0 && auth.snapshot.userIdentity?.role !== 'CLIENTVISITORUSER'">
            <div class="dropdown my-1">
              <button
                class="btn no-focus rounded-12 px-2 d-flex gap-md-3 p-0 align-items-center"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false">
                <div class="d-flex align-items-center gap-md-3">
                  <div>
                    <img
                      [src]="userInfo.profileImage?.fullLink"
                      class="profile-image"
                      alt="profile image"
                      onerror="this.src= 'assets/images/icons/earth.png'" loading="lazy" />
                  </div>
                  <div class="text-align-start d-none d-md-block">
                    <h6 class="text-white lh-sm m-0 fw-600 text-capitalize">
                      {{ userInfo.firstName }} {{ userInfo.middleName }} {{
                      userInfo.lastName }}
                    </h6>
                    <div class="text-info fs-14 text-capitalize">
                      {{ userInfo.email }}
                    </div>
                  </div>
                </div>
              </button>

              <ul
                class="dropdown-menu text-capitalize p-0 overflow-hidden w-100 mt-2 rounded-12"
                aria-labelledby="dropdownMenuButton">
                <ng-container *ngFor="let item of accountList">
                  <li>
                    <a
                      [routerLink]="[
                        '/' +
                          routing.dashboard +
                          '/' +
                          routing.account.module +
                          '/' +
                          item.link
                      ]"
                      routerLinkActive="active"
                      class="dropdown-item">
                      <div class="icon flex-grow-0">
                        <i class="{{ item.icon }} fs-5 text-info"></i>
                      </div>
                      {{ "security_dashboard.dash." + item.name | translate }}
                    </a>
                  </li>
                  <hr class="col-10 mis-auto m-0" />
                </ng-container>
                <li>
                  <a class="dropdown-item" (click)="support()">
                    <div class="icon bg-dark-o">
                      <i class="fa-solid fa-gears text-white"></i>
                    </div>
                    {{ "technicalSupport" | translate }}
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" (click)="logout()">
                    <div class="icon bg-danger-o">
                      <i class="fa-solid fa-power-off text-danger"></i>
                    </div>
                    {{ "logout" | translate }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="nav-block flex-grow-0 p-0 px-md-2" *ngIf="step == 0 && auth.snapshot.userIdentity?.role === 'CLIENTVISITORUSER'">
            <div class="dropdown my-1">
              <button
                class="btn no-focus rounded-12 px-2 d-flex gap-md-3 p-0 align-items-center"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                (click)="logout()"
                aria-expanded="false">
                <div class="d-flex align-items-center gap-md-3">
                  <a class="dropdown-item" (click)="logout()">
                    <div class="icon bg-danger-o">
                      <i class="fa-solid fa-power-off text-danger"></i>
                    </div>
                    {{ "logout" | translate }}
                  </a>
                </div></button></div></div>
        </div>
      </div>
    </div>
  </nav>

  <!--<div class="bg-primary position-sticky" *ngIf="step==0 &&packages">
    <ul class="nav text-nowrap nav-bottom gap-3 container flex-nowrap px-4
      overflow-auto">

      <ng-container *ngFor="let item of menu" class="nav-item">
        <ng-container *ngIf="!item.children">
          <li *appRole="item.role!">
            <a class="nav-link" [routerLink]="item.link"
              routerLinkActive="active">
              <img *ngIf="item.image" [src]="item.image" [alt]="item.name"
                class="menu_icon" />
              <ion-icon *ngIf="item.icon" [name]="item.icon"></ion-icon>
              <span class="link-name">{{
                "security_dashboard.dash." + item.name | translate
                }}</span>
            </a>
          </li>
        </ng-container>

        <ng-container *ngIf="item.children">
          <li *appRole="item.role!">
            <a cdkOverlayOrigin #trigger="cdkOverlayOrigin" class="nav-link
              dropdown-toggle" routerLinkActive="active"
              (click)="isOpen= true">
              <img *ngIf="item.image" [src]="item.image" [alt]="item.name"
                class="menu_icon" />
              <ion-icon *ngIf="item.icon" [name]="item.icon"></ion-icon>
              <span class="link-name">{{
                "security_dashboard.dash." + item.name | translate
                }}</span>
            </a>

            <ng-template [dir]="(lang.isAr | async) ? 'rtl' : 'ltr'"
              cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
              (detach)="isOpen= false"
              (backdropClick)="isOpen= false"
              [cdkConnectedOverlayHasBackdrop]="true" cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="trigger"
              [cdkConnectedOverlayOpen]="isOpen">
              <ul class="dropdown-menu border-0 shadow show">
                <li (click)="isOpen= false" *ngFor="let subLink of
                  item.children; let e= last">
                  <a class="dropdown-item text-info border-1 d-flex gap-3
                    align-items-center"
                    [routerLink]="item.link + '/' + subLink.link"
                    routerLinkActive="active" [class.border-bottom]="!e">
                    <ion-icon *ngIf="subLink.icon" [name]="subLink.icon"
                      size="small"></ion-icon>
                    <img *ngIf="subLink.image" [src]="subLink.image"
                      [alt]="subLink.name" class="menu_icon" />
                    <span>
                      {{
                      "security_dashboard.dash." + subLink.name | translate
                      }}
                    </span>
                  </a>
                </li>
              </ul>
            </ng-template>
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </div>
-->

  <nav class="navbar navbar-expand-lg bg-primary" *ngIf="step == 0 && packages">
    <div
      class="container-fluid nav text-nowrap nav-bottom gap-3 flex-nowrap px-4 overflow-auto">
      <button
        class="navbar-toggler text-white"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <i style="color: #ffffff;" class="fs-5">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="20"
            fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
          </svg></i>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 m-auto">
          <ng-container *ngFor="let item of menu" class="nav-item">
            <ng-container *ngIf="!item.children">
              <li *appRole="item.role!">
                <a
                  class="nav-link"
                  [routerLink]="item.link"
                  routerLinkActive="active">
                  <img
                    *ngIf="item.image"
                    [src]="item.image"
                    [alt]="item.name"
                    class="menu_icon" alt="menuIcon" loading="lazy" />
                  <ion-icon *ngIf="item.icon" [name]="item.icon"></ion-icon>
                  <span class="link-name">{{
                    "security_dashboard.dash." + item.name | translate
                    }}</span>
                </a>
              </li>
            </ng-container>
            <ng-container *ngIf="item.children">
              <li *appRole="item.role!">
                <a
                  cdkOverlayOrigin
                  #trigger="cdkOverlayOrigin"
                  class="nav-link dropdown-toggle"
                  routerLinkActive="active"
                  (click)="isOpen = true">
                  <img
                    *ngIf="item.image"
                    [src]="item.image"
                    [alt]="item.name"
                    class="menu_icon" alt="menuIcon" loading="lazy" />
                  <ion-icon *ngIf="item.icon" [name]="item.icon"></ion-icon>
                  <span class="link-name">{{
                    "security_dashboard.dash." + item.name | translate
                    }}</span>
                </a>

                <ng-template
                  [dir]="(lang.isAr | async) ? 'rtl' : 'ltr'"
                  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                  (detach)="isOpen = false"
                  (backdropClick)="isOpen = false"
                  [cdkConnectedOverlayHasBackdrop]="true"
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="trigger"
                  [cdkConnectedOverlayOpen]="isOpen">
                  <ul class="dropdown-menu border-0 shadow show">
                    <li
                      (click)="isOpen = false"
                      *ngFor="let subLink of item.children; let e = last">
                      <a
                        class="dropdown-item text-info border-1 d-flex gap-3 align-items-center"
                        [routerLink]="item.link + '/' + subLink.link"
                        routerLinkActive="active"
                        [class.border-bottom]="!e">
                        <ion-icon
                          *ngIf="subLink.icon"
                          [name]="subLink.icon"
                          size="small"></ion-icon>
                        <img
                          *ngIf="subLink.image"
                          [src]="subLink.image"
                          [alt]="subLink.name"
                          class="menu_icon" loading="lazy" alt="subMenuIcon" />
                        <span>
                          {{
                          "security_dashboard.dash." + subLink.name
                          | translate
                          }}
                        </span>
                      </a>
                    </li>
                  </ul>
                </ng-template>
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
  </nav>
  <div class="content flex-grow-1 bg-info-o overflow-auto">
    <router-outlet></router-outlet>
  </div>
</section>

<public-api-modal classList="modal-dialog-centered" [id]="modalId3">
  <h4 class="fw-700 text-align-center mb-3" translate="technicalSupport"></h4>
  <div class="d-flex mb-1 justify-content-center" *ngIf="technicalSupport >= 1">
    <p class="text-info fs-6" translate="emailSupport"></p>
    <a href="mailto: info&#64;takid.sa" class="px-2 color-primary text-decoration-none">info&#64;takid.sa</a>
  </div>
  <div class="d-flex mb-1 justify-content-center" *ngIf="technicalSupport >= 2">
    <p class="text-info fs-6" translate="phoneSupport"></p>
    <a href="tel:123-456-7890" class="px-2 color-primary text-decoration-none">123-456-7890</a>
  </div>
  <div class="d-flex justify-content-end gap-2">
    <button
      type="button"
      data-bs-dismiss="modal"
      class="btn rounded-8 px-4 py-2 btn-light"
      translate="cancel"></button>
  </div>
</public-api-modal>
